import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/');
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.logo}>
          <span style={styles.emoji}>🐣</span>
          <span style={styles.title}>Egg Incubator</span>
        </div>

        <div style={styles.navRight}>
          <nav style={styles.nav}>
            <Link to="/dashboard" style={styles.link}>Home</Link>
            <Link to="/history" style={styles.link}>History</Link>
            <Link to="/camera" style={styles.link}>Camera</Link>
          </nav>

          <button style={styles.logoutButton} onClick={handleLogout}>
            ออกจากระบบ
          </button>
        </div>
      </div>
    </header>
  );
}

const styles = {
  header: {
    backgroundColor: '#222',
    width: '100%',
    padding: '1rem 0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    position: 'sticky',
    top: 0,
    zIndex: 999
  },
  container: {
    maxWidth: '100%',
    padding: '0 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  emoji: {
    fontSize: '2rem'
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#fff'
  },
  navRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem'
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem'
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    fontSize: '1.1rem',
    fontWeight: '500',
    transition: 'color 0.2s',
  },
  logoutButton: {
    backgroundColor: 'transparent',
    color: 'white',
    border: '2px solid white',
    padding: '0.4rem 1rem',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 'bold',
    transition: 'background 0.3s, color 0.3s'
  }
};
